import { useState, useEffect } from 'react';
import EventApi from '../../Api/EventApi';
import { Event } from '../../Models/Event';

interface ConferenceData {
  springConference: Event | null;
  fallConference: Event | null;
  springSubEvents: Event[];
  fallSubEvents: Event[];
  loading: boolean;
}

export function useConferenceData() {
  const [data, setData] = useState<ConferenceData>({
    springConference: null,
    fallConference: null,
    springSubEvents: [],
    fallSubEvents: [],
    loading: true,
  });

  useEffect(() => {
    const loadConferences = async () => {
      try {
        // Get most recent conferences (not just current year)
        const [springRes, fallRes] = await Promise.all([
          EventApi.getMostRecentSpringConference().catch(() => ({ data: null })),
          EventApi.getMostRecentFallConference().catch(() => ({ data: null }))
        ]);
        
        const springConf = springRes.data;
        const fallConf = fallRes.data;
        
        // Get sub-events for each conference
        const springSubs = springConf 
          ? (await EventApi.getConferenceSubEvents(springConf.id)).data
          : [];
        const fallSubs = fallConf
          ? (await EventApi.getConferenceSubEvents(fallConf.id)).data
          : [];

        setData({
          springConference: springConf,
          fallConference: fallConf,
          springSubEvents: springSubs,
          fallSubEvents: fallSubs,
          loading: false,
        });
      } catch (error) {
        console.error('Failed to load conferences:', error);
        setData(prev => ({ ...prev, loading: false }));
      }
    };

    loadConferences();
  }, []);

  return data;
}
